import React from "react";

/**
 * Required connector name shown before connecting, so two connectors of the same
 * app (e.g. two Google accounts) can be told apart in the list.
 */
const ConnectorNameField = ({ value, onChange, error = "", disabled = false }) => (
  <div className="form-input-group connector-name-field">
    <label className="form-label" htmlFor="connector-name">
      Name
    </label>
    <input
      id="connector-name"
      type="text"
      className="form-control"
      value={value}
      maxLength={80}
      disabled={disabled}
      onChange={(event) => onChange?.(event.target.value)}
      aria-invalid={error ? "true" : "false"}
      aria-describedby={error ? "connector-name-error" : undefined}
    />
    {error ? (
      <p id="connector-name-error" className="error-message">
        {error}
      </p>
    ) : null}
  </div>
);

export default ConnectorNameField;
